"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Hamburger = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var Hamburger = function () { return (react_1.default.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M9 4.5a2.5 2.5 0 115 0 2.5 2.5 0 01-5 0zm2.5 5a2.5 2.5 0 100 5 2.5 2.5 0 000-5zM9 19.5a2.5 2.5 0 115 0 2.5 2.5 0 01-5 0z", clipRule: "evenodd" })); };
exports.Hamburger = Hamburger;
//# sourceMappingURL=hamburger.js.map